<template>
  <md-dialog
    :md-active.sync="dialog"
    :md-click-outside-to-close="false"
    :md-close-on-esc="false"
    @md-clicked-outside="closeDialog"
  >
    <md-card>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <h4 class="card-title">Relacionar Jefe administrativo</h4>
          </div>
          <form class="md-layout-item" id="customer_form" @submit.prevent="saveCustomer()">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-50">
                <md-field :class="validationClass('chief')">
                  <label for="chief">Jefes administrativos</label>
                  <md-select
                    data-vv-name="chief"
                    v-validate="modelValidations.chief"
                    v-model="payload.chief"
                    name="chief"
                    @change="payload.highway === null"
                  >
                    <md-option
                      v-for="chief in chiefs"
                      :value="chief.id"
                      :key="chief.id"
                    >{{ chief.name }}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-medium-size-50">
                <md-field :class="validationClass('highway')">
                  <label for="highway">Autopistas</label>
                  <md-select
                    data-vv-name="highway"
                    v-validate="modelValidations.highway"
                    v-model="payload.highway"
                    name="highway"
                    :disabled="!payload.chief"
                  >
                    <md-option
                      v-for="highway in filteredHighways"
                      :value="highway.id"
                      :key="highway.id"
                    >{{ highway.name }}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </form>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button type="submit" form="customer_form" class="md-success">
          {{
          editMode ? "Modificar" : "Crear"
          }}
        </md-button>
      </md-card-actions>
    </md-card>
  </md-dialog>
</template>

<script>
const modelValidations = {
  highway: {
    required: true,
  },
  chief: {
    required: true,
  },
};

export default {
  name: "AdminChiefForm",

  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    item: {
      type: Object,
      required: true,
    },
    chiefs: {
      type: Array,
      required: true,
    },
    highways: {
      type: Array,
      required: true,
    },
    relations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      highway: null,
      modelValidations,
      payload: {},
    };
  },
  computed: {
    filteredHighways() {
      return this.highways.filter((h) => {
        const { chief = "" } = this.payload;
        if (this.editMode) {
          return (
            !!chief &&
            this.relations
              .filter((r) => r.chief === chief)
              .some((r) => r.highway !== h.id || r.chief === this.item.chief)
          );
        }
        return (
          !!chief &&
          !this.relations
            .filter((r) => r.chief === chief)
            .some((r) => r.highway === h.id)
        );
      });
    },
    editMode() {
      return this.item && this.item.id;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    saveCustomer() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!this.editMode) {
            this.$emit("create", this.payload);
          } else {
            this.$emit("update", this.payload);
          }
        }
      });
    },
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.payload = newVal;
      },
    },
  },
  mounted() {
    if (this.editMode) {
      this.payload = this.item;
    }
  },
};
</script>

<style lang="css" scoped>
.md-card {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Customers/AdminChiefs/Edit.vue